/**
 * @file agendaHandoff.ts
 * @brief "Write new agenda" from a meeting's Setup: the written agenda comes
 *        back to Setup and is attached there.
 *
 * @details
 * DES 12-10-2026, the web twin of the phone's GlobalEvents AGENDA_CREATED.
 * Setup opens the editor (`/notes/new?kind=agenda`) with router state
 * `{ agendaPicker: true }`. On save the editor calls `offerNewAgenda` and goes
 * back one step; Setup takes the agenda once, on mount, with `takeNewAgenda`.
 * Setup keeps its own form in its history entry (`setupDraft`), so going back
 * finds the meeting as it was left.
 *
 * Held in memory only: a reload in between drops it, and the agenda is still
 * saved in the Agendas tab, so nothing is lost. Desktop gets the same code.
 *
 * @references
 * - FRONTEND/src/screens/Notes/NoteComposeScreen.tsx (fromPicker)
 * - FRONTEND/src/screens/MeetingIntelligence/MeetingSetup.tsx (AGENDA_CREATED)
 *
 * @author DES
 * @date 12-10-2026
 */

export type NewAgenda = { id: string; title: string };

/** Router state the editor reads to know it was opened from a meeting's picker. */
export type AgendaPickerState = { agendaPicker?: boolean };

let pending: NewAgenda | null = null;

export function offerNewAgenda(agenda: NewAgenda): void {
  pending = agenda;
}

/** The agenda written from the picker, once; null when there is none. */
export function takeNewAgenda(): NewAgenda | null {
  const out = pending;
  pending = null;
  return out;
}
